import React from 'react'
import { useTranslation } from 'react-i18next'
import { AiFillStar, AiOutlineStar } from 'react-icons/ai'
import Rating from 'react-rating'
import axios from '../../api/axiosConfig'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { useState } from 'react'
// import Rating from '@mui/material/Rating'
const RatingComponent = ({
  rating,
  setRating,
  id,
  item,
  favoriteRerender,
  setFavoriteRerender,
}) => {
  const { i18n } = useTranslation()
  const lang = i18n.language
  const user = useSelector((state) => state.userDataReducer.user)
  const [ratingValue, setRatingValue] = useState()
  const handleRating = async (value) => {
    setRating(value)
    let response
    try {
      response = await axios.post('ContentRateAPI/CreateContentRate', {
        contentId: item?.contentId,
        objectName: item?.objectName,
        objectId: item?.id,
        rate: value,
        ownerId: user,
      })
    } catch (error) {
      response = error
    }
    if (response?.data?.status === 200) {
      setFavoriteRerender(!favoriteRerender)
    }
  }
  return (
    <>
      {item?.isRate == true ? (
        <div className="rating-results">
          {[...Array(item?.userRate == null ? 0 : item?.userRate)]?.map(
            (item) => (
              <span className="active-rate" style={{ color: '#ffbf1f' }}>
                <AiFillStar />
              </span>
            ),
          )}
          {[
            ...Array(
              parseInt(5) -
                parseInt(
                  item?.userRate == null
                    ? 0
                    : item?.userRate
                    ? item?.userRate == null
                      ? 0
                      : item?.userRate
                    : parseInt(0),
                ),
            ),
          ]?.map((item) => (
            <span className="active-rate" style={{ color: '#81818154' }}>
              <AiFillStar />
            </span>
          ))}
        </div>
      ) : (
        <>
          <div className="rating-component">
            <Rating
              id={id}
              onChange={handleRating}
              direction={lang === 'ar-EG' ? 'rtl' : 'ltr'}
              initialRating={ratingValue}
              emptySymbol={
                <span className="not-active-rate">
                  <AiOutlineStar />
                </span>
              }
              fullSymbol={
                <span className="active-rate" style={{ color: '#ffbf1f' }}>
                  <AiFillStar />
                </span>
              }
            />

            {/* <>
        {rating > 0 ? (
          <>
            {[...Array(rating)]?.map((item) => (
              <span className="active-rate" style={{ color: '#ffbf1f' }}>
                <AiFillStar />
              </span>
            ))}
          </>
        ) : (
          <Rating
            id={id}
            onChange={handleRating}
            direction={lang === 'ar-EG' ? 'rtl' : 'ltr'}
            initialRating={ratingValue}
            emptySymbol={
              <span className="not-active-rate">
                <AiOutlineStar />
              </span>
            }
            fullSymbol={
              <span className="active-rate" style={{ color: '#ffbf1f' }}>
                <AiFillStar />
              </span>
            }
          />
        )}
      </> */}
          </div>
        </>
      )}
    </>

    //show starts if user login or not
    //   <>
    //   {user && item?.isRate == false ? (
    //     <>
    //       {' '}
    //       <Rating
    //         id={id}
    //         onChange={handleRating}
    //         direction={lang === 'ar-EG' ? 'rtl' : 'ltr'}
    //         initialRating={ratingValue}
    //         emptySymbol={
    //           <span className="not-active-rate">
    //             <AiOutlineStar />
    //           </span>
    //         }
    //         fullSymbol={
    //           <span className="active-rate" style={{ color: '#ffbf1f' }}>
    //             <AiFillStar />
    //           </span>
    //         }
    //       />
    //     </>
    //   ) : (
    //     <>
    //       {!user && item?.isRate == false ? (
    //         <div className="rated-values">
    //           {[
    //             ...Array(item?.rateContent == null ? 0 : item?.rateContent),
    //           ]?.map((item) => (
    //             <span className="active-rate" style={{ color: '#ffbf1f' }}>
    //               <AiFillStar />
    //             </span>
    //           ))}
    //           {[
    //             ...Array(
    //               parseInt(5) -
    //                 parseInt(
    //                   item?.rateContent == null
    //                     ? 0
    //                     : item?.rateContent
    //                     ? item?.rateContent == null
    //                       ? 0
    //                       : item?.rateContent
    //                     : parseInt(0),
    //                 ),
    //             ),
    //           ]?.map((item) => (
    //             <span className="active-rate" style={{ color: '#81818154' }}>
    //               <AiFillStar />
    //             </span>
    //           ))}
    //         </div>
    //       ) : (
    //         <>
    //           {user && item?.isRate == true && (
    //             <div className="rated-values">
    //               {[
    //                 ...Array(item?.rateContent == null ? 0 : item?.rateContent),
    //               ]?.map((item) => (
    //                 <span className="active-rate" style={{ color: '#ffbf1f' }}>
    //                   <AiFillStar />
    //                 </span>
    //               ))}
    //               {[
    //                 ...Array(
    //                   parseInt(5) -
    //                     parseInt(
    //                       item?.rateContent == null
    //                         ? 0
    //                         : item?.rateContent
    //                         ? item?.rateContent == null
    //                           ? 0
    //                           : item?.rateContent
    //                         : parseInt(0),
    //                     ),
    //                 ),
    //               ]?.map((item) => (
    //                 <span
    //                   className="active-rate"
    //                   style={{ color: '#81818154' }}
    //                 >
    //                   <AiFillStar />
    //                 </span>
    //               ))}
    //             </div>
    //           )}
    //         </>
    //       )}
    //     </>
    //   )}
    // </>
  )
}
export default RatingComponent
